<template>
  <div>
    <b-list-group>
      <b-list-group-item to="/area-do-participante/home" v-bind:class="[$route.name === 'dados' ? 'active': '']" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h6 class="mb-1">Meus Dados</h6>
        </div>
      </b-list-group-item>

      <b-list-group-item to="/area-do-participante/alterar-senha" v-bind:class="[$route.name === 'alterar_senha' ? 'active': '']" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h6 class="mb-1">Alterar Senha</h6>
        </div>
      </b-list-group-item>

      <!-- <b-list-group-item to="/area-do-participante/trabalhos" v-bind:class="[$route.name.includes('trabalhos') ? 'active': '']" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h6 class="mb-1">Trabalhos Científicos</h6>
        </div>
      </b-list-group-item> -->

      <b-list-group-item to="/area-do-participante/status" v-bind:class="[$route.name === 'status' ? 'active': '']" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h6 class="mb-1">Status da Inscrição</h6>
        </div>
      </b-list-group-item>

      <b-list-group-item to="/area-do-participante/certificados" v-bind:class="[$route.name === 'certificados' ? 'active': '']" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h6 class="mb-1">Certificados</h6>
        </div>
      </b-list-group-item>

      <b-list-group-item button @click="Sair()" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h6 class="mb-1">SAIR</h6>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { userKey } from '@/global'

export default {
  name: 'Menu',
  data () {
    return {
      // edicao: false
    }
  },
  methods: {
    Sair () {
      localStorage.removeItem(userKey)
      this.$store.commit('setUser', null)
      this.$router.push({ path: '/' })
    }
  }
}
</script>
